import(/* webpackMode: "eager", webpackExports: ["MainPage"] */ "/home/runner/work/brics-website/brics-website/entities/main-page/main-page.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
